import { render } from "./HomeSettingsIcon.vue?vue&type=template&id=54921205"
import script from "./HomeSettingsIcon.vue?vue&type=script&lang=js"
export * from "./HomeSettingsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__